import React from 'react';
import WarningIcon from "../../components/icons/warning";

export default function BestEmployerError() {
    return(
        <div className='stat forbes'>
            <div className='error'>
                <div className="icon"><WarningIcon /></div>
                <span className="error_text">No data could be retrieved from Forbes</span>
            </div>
        </div>
    )
}